import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { EntityCrudService } from '@data/entity-crud.service';
import { CourseGeneral } from '@data/course-general/course-general.model';

@Injectable({
  providedIn: 'root',
})
export class CourseGeneralService extends EntityCrudService<CourseGeneral, CourseGeneral> {
  constructor() {
    const http = inject(HttpClient);

    super('course-general', http);
  }
}
